import { GroupingLevel } from 'api/model';

/**
 * Etikett för en grupperingsperiod. Backend skickar periodens start som midnatt UTC
 * (`GetGroupKey`), så datumet läses i UTC — annars hamnar en vecka på söndagen före.
 */
const periodLabel = (date: Date | string, groupingLevel: GroupingLevel) => {
  const d = new Date(date);
  const iso = d.toISOString().slice(0, 10);
  switch (groupingLevel) {
    case GroupingLevel.Week: {
      // ISO-veckonummer: torsdagen i veckan avgör året.
      const thursday = new Date(
        Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 3)
      );
      const firstThursday = new Date(Date.UTC(thursday.getUTCFullYear(), 0, 4));
      const week =
        1 +
        Math.round(
          ((thursday.getTime() - firstThursday.getTime()) / 86400000 -
            3 +
            ((firstThursday.getUTCDay() + 6) % 7)) /
            7
        );
      return `v.${week} (${iso})`;
    }
    case GroupingLevel.Month:
      return iso.slice(0, 7);
    case GroupingLevel.Year:
      return iso.slice(0, 4);
    default:
      return iso;
  }
};

export default periodLabel;
